import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {load} from 'flows/docs/w92';

export class RetrieveW9 extends React.PureComponent {
  componentDidMount() {
    this.props.load({id: this.props.params.allocationId});
  }
  render() {
    return (
      <div>
        <img src="/images/ring.svg" alt="Loading" />
      </div>
    );
  }
}

RetrieveW9.propTypes = {
  load: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export default connect(null, {load})(RetrieveW9);



// WEBPACK FOOTER //
// ./web/flows/docs/w9/index.js